import type { VorgabenResponse } from '@/features/Vorgaben/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class VorgabenHttpService extends HttpService {
  loadVorgabenByCalculationId(
    berechnungsId: string,
  ): HttpClientResponse<VorgabenResponse> {
    return this.httpClient.get(`vorgaben/${berechnungsId}`);
  }
}
